export class LocationDto {
	id: number;
	name: string;
	guid?: string;
}
